<template>
  <BreadCrumb PageTitle="Gestion des zones" />
  <ZonesSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ZonesSettings from "../../components/Generals/Zones/ZonesSettings.vue";
export default defineComponent({
  name: "ZonesSettingsPage",
  components: {
    BreadCrumb,
    ZonesSettings,
  },
});
</script>